import type { Lang } from '@buildiary/core';
import { ar } from './ar';
import { en, type Key } from './en';
import { ur } from './ur';

export type { Key };
export type Vars = Record<string, string | number>;

const DICT: Record<Lang, Partial<Record<Key, string>>> = { en, ur, ar };

/** Translates a key; Urdu and Arabic fall back to English for any key they do not have. */
export function translate(lang: Lang, key: Key, vars?: Vars): string {
  let s = DICT[lang][key] ?? en[key];
  if (vars) for (const [k, v] of Object.entries(vars)) s = s.split(`{${k}}`).join(String(v));
  return s;
}

export function hasKey(key: string): key is Key {
  return Object.prototype.hasOwnProperty.call(en, key);
}

export function dirOf(lang: Lang): 'ltr' | 'rtl' {
  return lang === 'en' ? 'ltr' : 'rtl';
}

/** Locale for Intl with Western digits always (brand rule: figures stay Latin). */
export function localeOf(lang: Lang): string {
  return lang === 'ur' ? 'ur-PK-u-nu-latn' : lang === 'ar' ? 'ar-u-nu-latn' : 'en-GB';
}

export const LANG_NAME: Record<Lang, string> = { en: 'English', ur: 'اردو', ar: 'العربية' };
export const LANGS: Lang[] = ['en', 'ur', 'ar'];
